/** Mapeamento layout-key / card → feature do plano do dono (Task) */
export const TASK_SECTION_PLAN_KEYS = {
  informacoesTask: 'taskInformacoes',
  checklist: 'taskChecklist',
  anexos: 'taskAnexos',
  cor: 'taskCor',
  financeiro: 'taskFinanceiro',
  progressoTarefa: 'taskProcesso',
  tags: 'taskTags',
  usuariosAtribuidos: 'taskUsuariosAtribuidos',
  controlesAtividade: 'taskControleAtividade',
  agendamento: 'taskAgendamento',
  historicoChat: 'taskHistoricoChat'
}

/** Cards do LeadDetailModal → feature CRM */
export const CRM_LEAD_CARD_PLAN_KEYS = {
  contactInfo: 'crmInformacoesContato',
  businessInfo: 'crmInformacoesNegocio',
  origin: 'crmOrigemLead',
  leadColor: 'crmCorLead',
  assignedUsers: 'crmUsuariosAtribuidos',
  agendamento: 'crmAgendamento',
  tags: 'crmTags',
  anexos: 'crmAnexos',
  internalChat: 'crmHistoricoChat'
}

/** Preview Kanban toggle → feature Task (quando aplicável) */
export const KANBAN_PREVIEW_PLAN_KEYS = {
  showDescription: 'taskInformacoes',
  showTagsExpanded: 'taskTags',
  showUsers: 'taskUsuariosAtribuidos',
  showActivityControls: 'taskControleAtividade',
  showSchedule: 'taskAgendamento',
  showChecklist: 'taskChecklist',
  showAttachments: 'taskAnexos',
  showCreatedAt: 'taskInformacoes',
  showUpdatedAt: 'taskInformacoes',
  showFinanceiro: 'taskFinanceiro',
  showTaskProgress: 'taskProcesso'
}
